export const WIDGET_MARKETPLACE_WINDOW_ID = 'widgetMarketplace'
